import React from 'react';
import { Edit } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const MarketLocationTypeRateSettingEdit = () => (
  <Edit
    mutationMode="pessimistic"
    transform={getTransform(['market_id', 'location_type_id'], 'market_location_type_rate_setting')}
  >
    <RateSettingsForm settingsField="market_location_type_rate_setting" />
  </Edit>
);

export default MarketLocationTypeRateSettingEdit;
